import { useEffect, useState } from "react";
import styles from "./HomesteadSuccessModal.module.css";
import andyHdLogo from "@/assets/andyhdlogo.png";
import { Gifs } from "@/assets/gifs";
import { Modal } from "@/shared/modal";

type HomesteadSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDone?: () => void;
};

export const HomesteadSuccessModal = ({ isOpen, onClose, onDone }: HomesteadSuccessModalProps) => {
  const [secondsLeft, setSecondsLeft] = useState(7);

  useEffect(() => {
    if (!isOpen) return;
    setSecondsLeft(7);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    if (secondsLeft <= 0) {
      onDone?.();
      onClose();
      return;
    }
    const timer = window.setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [isOpen, secondsLeft, onDone, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
      closeOnBackdropClick={false}
      closeOnEscape={false}
      unconstrained
      className={styles.modal}
      bodyClassName={styles.homesteadSuccessModalBody}
      ariaLabel="Protest Successfully Completed"
    >
      <h2 className={styles.title}>Your Homestead Exemption Has Been Successfully Submitted !</h2>
      <img src={Gifs.andyConfetti} alt="Confetti celebration" className={styles.confettiGif} />

      <div className={styles.checkWrap} aria-hidden="true">
        <svg width="72" height="72" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M7.8 12.6l2.8 2.7 5.7-6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className={styles.character} aria-hidden="true">
        <img className={styles.characterLogo} src={andyHdLogo} alt="" />
      </div>
      <div className={styles.countdown}>Redirecting to home in {secondsLeft}s</div>
    </Modal>
  );
};
